$(function() {
    "use strict";

    $(document).on('ready', function() {

    });
});